import EstimatedHarvestRoutes from './estimated_harvest';

export default [...EstimatedHarvestRoutes];
